import { useTranslation, Trans } from "react-i18next";

import { useState } from "react";

import num from '../../img/Trading/num.png'
import f1 from '../../img/Trading/f1.png'
import f2 from '../../img/Trading/f2.png'
import f3 from '../../img/Trading/f3.png'
import f4 from '../../img/Trading/f4.png'
import f5 from '../../img/Trading/f5.png'
import f6 from '../../img/Trading/f6.png'

import { motion, AnimatePresence } from "framer-motion";

function Switcher () {

    const { t } = useTranslation();

    const [active, setActive] = useState(0);

    const data = [
        {
            title: t('trading.3'),
        },
        {
            title: t('trading.4'),
        },
        {
            title: t('trading.5'),
        },
        {
            title: t('trading.6'),
        },
        {
            title: t('trading.7'),
        },
        {
            title: t('trading.8'),
        },
    ]

    const [openIndex, setOpenIndex] = useState(null);

    const faq0 = [
        {
            question: t('trading.faq.1'),
            answer: t('trading.faq.2'),
        },
        {
            question: t('trading.faq.3'),
            answer: t('trading.faq.4'),
        },
        {
            question: t('trading.faq.5'),
            answer: t('trading.faq.6'),
        },
        {
            question: t('trading.faq.7'),
            answer: t('trading.faq.8'),
        },
        {
            question: t('trading.faq.9'),
            answer: t('trading.faq.10'),
        },
        {
            question: t('trading.faq.11'),
            answer: t('trading.faq.12'),
        },
        {
            question: t('trading.faq.13'),
            answer: t('trading.faq.14'),
        },
    ]

    const faq1 = [
        {
            question: t('trading.29'),
            answer: t('trading.30'),
        },
        {
            question: t('trading.31'),
            answer: t('trading.32'),    
        },
        {
            question: t('trading.33'),
            answer: t('trading.34'),    
        },
        {
            question: t('trading.35'),
            answer: t('trading.36'),    
        },
        {
            question: t('trading.37'),
            answer: t('trading.38'),    
        }
    ]

    const faq2 = [
        {
            question: t('trading.53'),
            answer: t('trading.54'),
        },
        {
            question: t('trading.55'),
            answer: t('trading.56'),
        },
        {
            question: t('trading.57'),
            answer: t('trading.58'),
        },
        {
            question: t('trading.59'),
            answer: t('trading.60'),
        },
        {
            question: t('trading.61'),
            answer: t('trading.62'),
        },
    ]

    const faq3 = [
        {
            question: t('trading.69'),
            answer: t('trading.70'),
        },
        {
            question: t('trading.71'),
            answer: t('trading.72'),
        },
        {
            question: t('trading.73'),
            answer: t('trading.74'),
        },
        {
            question: t('trading.75'),
            answer: t('trading.76'),
        },
        {
            question: t('trading.77'),
            answer: t('trading.78'),
        },
    ]    
    
    const faq4 = [
        {
            question: t('trading.86'),
            answer: t('trading.87'),
        },
        {
            question: t('trading.88'),
            answer: t('trading.89'),
        },
        {
            question: t('trading.90'),
            answer: t('trading.91'),
        },
        {
            question: t('trading.92'),
            answer: t('trading.93'),
        },
        {
            question: t('trading.94'),
            answer: t('trading.95'),
        },
    ]
    const faq5 = [
        {
            question: t('trading.103'),
            answer: t('trading.104'),
        },
        {
            question: t('trading.105'),
            answer: t('trading.106'),
        },
        {
            question: t('trading.107'),
            answer: t('trading.108'),
        },
        {
            question: t('trading.109'),
            answer: t('trading.110'),
        },
        {
            question: t('trading.111'),
            answer: t('trading.112'),
        },
    ]
    return(
        <div className="overflow-hidden relative z-50">
            <div className="w-full h-[40px] xl:h-[60px] bg-[#131313]"></div>
            <div className="w-full h-[40px] xl:h-[60px] rounded-t-[40px] xl:rounded-t-[60px] bg-white mt-[-40px] xl:mt-[-60px]"></div>
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto mt-[60px] xl:mt-[80px]">
                <div className="flex flex-wrap gap-[10px] xl:gap-[20px] justify-center">
                    {data.map((item, index) => (
                        <div key={index} className={`${active === index ? 'bg-[#A3E9E6] border-[#A3E9E6]' : 'border-[#000000]'} border text-[#131313] py-[12px] px-[40px] rounded-[60px] transition-all cursor-pointer`} onClick={() => setActive(index)}>
                            <p className="roboto">{item.title}</p>
                        </div>
                    ))}
                </div>
                {active === 0 && (
                    <div className="mt-[50px]">
                        <div className="flex flex-col xl:flex-row justify-between">
                            <div>
                                <p className="manrope xl:text-[48px] text-[24px] leading-[1.2] font-[500]">{t('trading.3')}</p>
                                <p className="roboto mt-[20px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[497px]">{t('trading.9')}</p>
                                <p className="mt-[40px] xl:mt-[80px] manrope text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('trading.10')}</p>
                                <div className="flex gap-[16px] xl:gap-[26px] mt-[20px] xl:mt-[50px]">
                                    <img src={num} className="flex-shrink-0" alt="" />
                                    <div className="mt-[5px] xl:mt-0">
                                        <p className="roboto text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[414px]">{t('trading.11')}</p>
                                        <p className="roboto mt-[58px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[414px]">{t('trading.12')}</p>
                                        <p className="roboto mt-[55px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[414px]">{t('trading.13')}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-[40px] xl:mt-0">
                                <p className="manrope text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('trading.14')}</p>
                                <p className="roboto mt-[20px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[497px]">{t('trading.15')}</p>
                                <p className="manrope mt-[40px] xl:mt-[70px] text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('trading.16')}</p>
                                <div className="flex gap-[15px] xl:gap-[22px] mt-[30px] xl:mt-[50px] items-center">
                                    <div className="w-[4px] h-[4px] xl:w-[6px] xl:h-[6px] bg-black rounded-full flex-shrink-0"></div>
                                    <p className="roboto text-[14px] xl:text-[16px] text-[#000000B2] xl:max-w-[497px]">{t('trading.17')}</p>
                                </div>
                                <div className="flex gap-[15px] xl:gap-[22px] mt-[10px] items-center">
                                    <div className="w-[4px] h-[4px] xl:w-[6px] xl:h-[6px] bg-black rounded-full flex-shrink-0"></div>
                                    <p className="roboto text-[14px] xl:text-[16px] text-[#000000B2] xl:max-w-[497px]">{t('trading.18')}</p>
                                </div>
                                <div className="flex gap-[15px] xl:gap-[22px] mt-[10px] items-center">
                                    <div className="w-[4px] h-[4px] xl:w-[6px] xl:h-[6px] bg-black rounded-full flex-shrink-0"></div>
                                    <p className="roboto text-[14px] xl:text-[16px] text-[#000000B2] xl:max-w-[497px]">{t('trading.19')}</p>
                                </div>
                                <div className="flex gap-[15px] xl:gap-[22px] mt-[10px] items-center">
                                    <div className="w-[4px] h-[4px] xl:w-[6px] xl:h-[6px] bg-black rounded-full flex-shrink-0"></div>
                                    <p className="roboto text-[14px] xl:text-[16px] text-[#000000B2] xl:max-w-[497px]">{t('trading.20')}</p>
                                </div>
                                <div className="flex gap-[15px] xl:gap-[22px] mt-[10px] items-center">
                                    <div className="w-[4px] h-[4px] xl:w-[6px] xl:h-[6px] bg-black rounded-full flex-shrink-0"></div>
                                    <p className="roboto text-[14px] xl:text-[16px] text-[#000000B2] xl:max-w-[497px]">{t('trading.21')}</p>
                                </div>
                                <div className="flex gap-[15px] xl:gap-[22px] mt-[10px] items-center">
                                    <div className="w-[4px] h-[4px] xl:w-[6px] xl:h-[6px] bg-black rounded-full flex-shrink-0"></div>
                                    <p className="roboto text-[14px] xl:text-[16px] text-[#000000B2] xl:max-w-[497px]">{t('trading.22')}</p>
                                </div>
                            </div>
                        </div>
                        <div className="mt-[40px] xl:mt-[100px] flex flex-col md:flex-row gap-[10px] xl:gap-[20px]">
                            <div className="flex flex-col gap-[10px] xl:gap-[20px]">
                                <div className="px-[20px] xl:px-[40px] py-[40px] bg-[#131313] rounded-[20px] md:w-[600px] xl:h-[218px]">
                                    <p className="manrope text-[16px] xl:text-[20px] text-[#FFFFFF]">{t('trading.23')}</p>
                                    <p className="roboto mt-[20px] text-[#FFFFFFB2] text-[12px] xl:text-[14px] font-[300] xl:max-w-[497px]">{t('trading.24')}</p>
                                </div>
                                <div className="px-[20px] xl:px-[40px] py-[40px] bg-[#131313] rounded-[20px] md:w-[600px] xl:h-[218px]">
                                    <p className="manrope text-[16px] xl:text-[20px] text-[#FFFFFF]">{t('trading.25')}</p>
                                    <p className="roboto mt-[20px] text-[#FFFFFFB2] text-[12px] xl:text-[14px] font-[300] xl:max-w-[497px]">{t('trading.26')}</p>
                                </div>
                            </div>
                            <div className="relative overflow-hidden">
                                <img src={f1} className="h-full w-full object-cover" alt="" />
                                <p className="roboto italic bottom-[20px] xl:bottom-[50px] left-[20px] right-[20px] xl:left-[50px] text-[#FFFFFFB2] text-[12px] xl:text-[14px] xl:max-w-[497px] absolute">{t('trading.27')}</p>
                            </div>
                        </div>
                        <div className="mt-[60px] xl:mt-[100px] flex flex-col items-center  ">
                            <p className="text-center manrope text-[16px] xl:text-[20px] leading-[1.2] font-[500]">{t('trading.28')}</p>
                            <div className="xl:w-[807px] mt-[20px] xl:mt-[40px] flex flex-col gap-[12px]">
                                {faq0.map((item, index) => {
                                    const isOpen = openIndex === index;
                                    return (
                                        <div
                                            key={index}
                                            className="border-[2px] rounded-[40px] border-[#0000001A] py-[15px] cursor-pointer select-none"
                                            onClick={() => setOpenIndex(isOpen ? null : index)}
                                        >
                                            <div className="flex justify-between items-center">
                                                <p className="roboto text-[14px] xl:text-[16px] text-[#000000B2] px-[20px] xl:px-[40px]">
                                                    {item.question}
                                                </p>
                                                <motion.div
                                                    animate={{ rotate: isOpen ? 45 : 0 }}
                                                    transition={{ duration: 0.3 }}
                                                    className="flex-shrink-0"
                                                >
                                                    <div className="w-[30px] mx-[15px] h-[30px] flex items-center justify-center flex-shrink-0 bg-[#131313] rounded-full"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"> <path d="M12.8577 8.38494H8.66511V12.8104C8.66511 13.0452 8.57676 13.2703 8.41951 13.4363C8.26226 13.6023 8.04898 13.6955 7.8266 13.6955C7.60421 13.6955 7.39093 13.6023 7.23368 13.4363C7.07643 13.2703 6.98809 13.0452 6.98809 12.8104V8.38494H2.79554C2.57315 8.38494 2.35988 8.29169 2.20263 8.12571C2.04537 7.95972 1.95703 7.73459 1.95703 7.49985C1.95703 7.26511 2.04537 7.03998 2.20263 6.874C2.35988 6.70801 2.57315 6.61476 2.79554 6.61476H6.98809V2.18929C6.98809 1.95455 7.07643 1.72942 7.23368 1.56344C7.39093 1.39745 7.60421 1.3042 7.8266 1.3042C8.04898 1.3042 8.26226 1.39745 8.41951 1.56344C8.57676 1.72942 8.66511 1.95455 8.66511 2.18929V6.61476H12.8577C13.08 6.61476 13.2933 6.70801 13.4506 6.874C13.6078 7.03998 13.6962 7.26511 13.6962 7.49985C13.6962 7.73459 13.6078 7.95972 13.4506 8.12571C13.2933 8.29169 13.08 8.38494 12.8577 8.38494Z" fill="white"/> </svg></div>
                                                </motion.div>
                                            </div>

                                            <AnimatePresence>
                                                {isOpen && (
                                                    <motion.div
                                                        initial={{ opacity: 0, height: 0 }}
                                                        animate={{ opacity: 1, height: "auto" }}
                                                        exit={{ opacity: 0, height: 0 }}
                                                        transition={{ duration: 0.4, ease: "easeInOut" }}
                                                        className="overflow-hidden"
                                                    >
                                                        <p className="roboto mx-[20px] xl:mx-[40px] mt-[15px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[807px]">
                                                            {item.answer}
                                                        </p>
                                                    </motion.div>
                                                )}
                                            </AnimatePresence>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                )}
                {active === 1 && (
                    <div className="mt-[50px]">
                        <div className="flex flex-col xl:flex-row justify-between">
                            <div>
                                <p className="manrope xl:text-[48px] text-[24px] leading-[1.2] font-[500]">{t('trading.4')}</p>
                                <p className="roboto mt-[20px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[497px]">{t('trading.39')}</p>
                                <p className="manrope text-[16px] xl:text-[20px] font-[500] leading-[1.2] xl:mt-[60px] mt-[40px]">{t('trading.40')}</p>
                                <p className="roboto mt-[20px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[497px]">{t('trading.41')}</p>
                            </div>
                            <div className="mt-[40px] xl:mt-0">
                                <p className="mt-[40px] xl:mt-0 manrope text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('trading.42')}</p>
                                <div className="flex gap-[16px] xl:gap-[26px] mt-[20px] xl:mt-[50px]">
                                    <img src={num} className="flex-shrink-0" alt="" />
                                    <div className="mt-[5px] xl:mt-0">
                                        <p className="roboto text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[414px]">{t('trading.43')}</p>
                                        <p className="roboto mt-[58px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[414px]">{t('trading.44')}</p>
                                        <p className="roboto mt-[55px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[414px]">{t('trading.45')}</p>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        <div className="mt-[40px] xl:mt-[100px] flex flex-col md:flex-row gap-[10px] xl:gap-[20px]">
                            <div className="flex flex-col gap-[10px] xl:gap-[20px]">
                                <div className="px-[20px] xl:px-[40px] py-[40px] bg-[#131313] rounded-[20px] md:w-[600px] xl:h-[218px]">
                                    <p className="manrope text-[16px] xl:text-[20px] text-[#FFFFFF]">{t('trading.23')}</p>
                                    <p className="roboto mt-[20px] text-[#FFFFFFB2] text-[12px] xl:text-[14px] font-[300] xl:max-w-[497px]">{t('trading.24')}</p>
                                </div>
                                <div className="px-[20px] xl:px-[40px] py-[40px] bg-[#131313] rounded-[20px] md:w-[600px] xl:h-[218px]">
                                    <p className="manrope text-[16px] xl:text-[20px] text-[#FFFFFF]">{t('trading.25')}</p>
                                    <p className="roboto mt-[20px] text-[#FFFFFFB2] text-[12px] xl:text-[14px] font-[300] xl:max-w-[497px]">{t('trading.26')}</p>
                                </div>
                            </div>
                            <div className="relative overflow-hidden">
                                <img src={f2} className="h-full w-full object-cover" alt="" />
                                <p className="roboto italic bottom-[20px] xl:bottom-[50px] left-[20px] right-[20px] xl:left-[50px] text-[#FFFFFFB2] text-[12px] xl:text-[14px] xl:max-w-[497px] absolute">{t('trading.27')}</p>
                            </div>
                        </div>
                        <div className="mt-[60px] xl:mt-[100px] flex flex-col items-center  ">
                            <p className="text-center manrope text-[16px] xl:text-[20px] leading-[1.2] font-[500]">{t('trading.28')}</p>
                            <div className="xl:w-[807px] mt-[20px] xl:mt-[40px] flex flex-col gap-[12px]">
                                {faq1.map((item, index) => {
                                    const isOpen = openIndex === index;
                                    return (
                                        <div
                                            key={index}
                                            className="border-[2px] rounded-[40px] border-[#0000001A] py-[15px] cursor-pointer select-none"
                                            onClick={() => setOpenIndex(isOpen ? null : index)}
                                        >
                                            <div className="flex justify-between items-center">
                                                <p className="roboto text-[14px] xl:text-[16px] text-[#000000B2] px-[20px] xl:px-[40px]">
                                                    {item.question}
                                                </p>
                                                <motion.div
                                                    animate={{ rotate: isOpen ? 45 : 0 }}
                                                    transition={{ duration: 0.3 }}
                                                    className="flex-shrink-0"
                                                >
                                                    <div className="w-[30px] mx-[15px] h-[30px] flex items-center justify-center flex-shrink-0 bg-[#131313] rounded-full"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"> <path d="M12.8577 8.38494H8.66511V12.8104C8.66511 13.0452 8.57676 13.2703 8.41951 13.4363C8.26226 13.6023 8.04898 13.6955 7.8266 13.6955C7.60421 13.6955 7.39093 13.6023 7.23368 13.4363C7.07643 13.2703 6.98809 13.0452 6.98809 12.8104V8.38494H2.79554C2.57315 8.38494 2.35988 8.29169 2.20263 8.12571C2.04537 7.95972 1.95703 7.73459 1.95703 7.49985C1.95703 7.26511 2.04537 7.03998 2.20263 6.874C2.35988 6.70801 2.57315 6.61476 2.79554 6.61476H6.98809V2.18929C6.98809 1.95455 7.07643 1.72942 7.23368 1.56344C7.39093 1.39745 7.60421 1.3042 7.8266 1.3042C8.04898 1.3042 8.26226 1.39745 8.41951 1.56344C8.57676 1.72942 8.66511 1.95455 8.66511 2.18929V6.61476H12.8577C13.08 6.61476 13.2933 6.70801 13.4506 6.874C13.6078 7.03998 13.6962 7.26511 13.6962 7.49985C13.6962 7.73459 13.6078 7.95972 13.4506 8.12571C13.2933 8.29169 13.08 8.38494 12.8577 8.38494Z" fill="white"/> </svg></div>
                                                </motion.div>
                                            </div>

                                            <AnimatePresence>
                                                {isOpen && (
                                                    <motion.div
                                                        initial={{ opacity: 0, height: 0 }}
                                                        animate={{ opacity: 1, height: "auto" }}
                                                        exit={{ opacity: 0, height: 0 }}
                                                        transition={{ duration: 0.4, ease: "easeInOut" }}
                                                        className="overflow-hidden"
                                                    >
                                                        <p className="roboto mx-[20px] xl:mx-[40px] mt-[15px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[807px]">
                                                            {item.answer}
                                                        </p>
                                                    </motion.div>
                                                )}
                                            </AnimatePresence>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                )}
                {active === 2 && (
                    <div className="mt-[50px]">
                        <div className="flex flex-col xl:flex-row justify-between">
                            <div>
                                <p className="manrope xl:text-[48px] text-[24px] leading-[1.2] font-[500]">{t('trading.5')}</p>
                                <p className="roboto mt-[20px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[497px]">{t('trading.46')}</p>
                                <p className="manrope text-[16px] xl:text-[20px] font-[500] leading-[1.2] xl:mt-[40px] mt-[20px]">{t('trading.47')}</p>
                                <p className="roboto mt-[20px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[497px]">{t('trading.48')}</p>
                            </div>
                            <div className="mt-[40px] xl:mt-0">
                                <p className="mt-[40px] xl:mt-0 manrope text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('trading.49')}</p>
                                <div className="flex gap-[16px] xl:gap-[26px] mt-[20px] xl:mt-[50px]">
                                    <img src={num} className="flex-shrink-0" alt="" />
                                    <div className="mt-[5px] xl:mt-0">
                                        <p className="roboto text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[414px]">{t('trading.50')}</p>
                                        <p className="roboto mt-[58px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[414px]">{t('trading.51')}</p>
                                        <p className="roboto mt-[55px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[414px]">{t('trading.52')}</p>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        <div className="mt-[40px] xl:mt-[100px] flex flex-col md:flex-row gap-[10px] xl:gap-[20px]">
                            <div className="flex flex-col gap-[10px] xl:gap-[20px]">
                                <div className="px-[20px] xl:px-[40px] py-[40px] bg-[#131313] rounded-[20px] md:w-[600px] xl:h-[218px]">
                                    <p className="manrope text-[16px] xl:text-[20px] text-[#FFFFFF]">{t('trading.23')}</p>
                                    <p className="roboto mt-[20px] text-[#FFFFFFB2] text-[12px] xl:text-[14px] font-[300] xl:max-w-[497px]">{t('trading.24')}</p>
                                </div>
                                <div className="px-[20px] xl:px-[40px] py-[40px] bg-[#131313] rounded-[20px] md:w-[600px] xl:h-[218px]">
                                    <p className="manrope text-[16px] xl:text-[20px] text-[#FFFFFF]">{t('trading.25')}</p>
                                    <p className="roboto mt-[20px] text-[#FFFFFFB2] text-[12px] xl:text-[14px] font-[300] xl:max-w-[497px]">{t('trading.26')}</p>
                                </div>
                            </div>
                            <div className="relative overflow-hidden">
                                <img src={f3} className="h-full w-full object-cover" alt="" />
                                <p className="roboto italic bottom-[20px] xl:bottom-[50px] left-[20px] right-[20px] xl:left-[50px] text-[#FFFFFFB2] text-[12px] xl:text-[14px] xl:max-w-[497px] absolute">{t('trading.27')}</p>
                            </div>
                        </div>
                        <div className="mt-[60px] xl:mt-[100px] flex flex-col items-center  ">
                            <p className="text-center manrope text-[16px] xl:text-[20px] leading-[1.2] font-[500]">{t('trading.28')}</p>
                            <div className="xl:w-[807px] mt-[20px] xl:mt-[40px] flex flex-col gap-[12px]">
                                {faq2.map((item, index) => {
                                    const isOpen = openIndex === index;
                                    return (
                                        <div
                                            key={index}
                                            className="border-[2px] rounded-[40px] border-[#0000001A] py-[15px] cursor-pointer select-none"
                                            onClick={() => setOpenIndex(isOpen ? null : index)}
                                        >
                                            <div className="flex justify-between items-center">
                                                <p className="roboto text-[14px] xl:text-[16px] text-[#000000B2] px-[20px] xl:px-[40px]">
                                                    {item.question}
                                                </p>
                                                <motion.div
                                                    animate={{ rotate: isOpen ? 45 : 0 }}
                                                    transition={{ duration: 0.3 }}
                                                    className="flex-shrink-0"
                                                >
                                                    <div className="w-[30px] mx-[15px] h-[30px] flex items-center justify-center flex-shrink-0 bg-[#131313] rounded-full"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"> <path d="M12.8577 8.38494H8.66511V12.8104C8.66511 13.0452 8.57676 13.2703 8.41951 13.4363C8.26226 13.6023 8.04898 13.6955 7.8266 13.6955C7.60421 13.6955 7.39093 13.6023 7.23368 13.4363C7.07643 13.2703 6.98809 13.0452 6.98809 12.8104V8.38494H2.79554C2.57315 8.38494 2.35988 8.29169 2.20263 8.12571C2.04537 7.95972 1.95703 7.73459 1.95703 7.49985C1.95703 7.26511 2.04537 7.03998 2.20263 6.874C2.35988 6.70801 2.57315 6.61476 2.79554 6.61476H6.98809V2.18929C6.98809 1.95455 7.07643 1.72942 7.23368 1.56344C7.39093 1.39745 7.60421 1.3042 7.8266 1.3042C8.04898 1.3042 8.26226 1.39745 8.41951 1.56344C8.57676 1.72942 8.66511 1.95455 8.66511 2.18929V6.61476H12.8577C13.08 6.61476 13.2933 6.70801 13.4506 6.874C13.6078 7.03998 13.6962 7.26511 13.6962 7.49985C13.6962 7.73459 13.6078 7.95972 13.4506 8.12571C13.2933 8.29169 13.08 8.38494 12.8577 8.38494Z" fill="white"/> </svg></div>
                                                </motion.div>
                                            </div>

                                            <AnimatePresence>
                                                {isOpen && (
                                                    <motion.div
                                                        initial={{ opacity: 0, height: 0 }}
                                                        animate={{ opacity: 1, height: "auto" }}
                                                        exit={{ opacity: 0, height: 0 }}
                                                        transition={{ duration: 0.4, ease: "easeInOut" }}
                                                        className="overflow-hidden"
                                                    >
                                                        <p className="roboto mx-[20px] xl:mx-[40px] mt-[15px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[807px]">
                                                            {item.answer}
                                                        </p>
                                                    </motion.div>
                                                )}
                                            </AnimatePresence>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                )}
                {active === 3 && (
                    <div className="mt-[50px]">
                        <div className="flex flex-col xl:flex-row justify-between">
                            <div>
                                <p className="manrope xl:text-[48px] text-[24px] leading-[1.2] font-[500]">{t('trading.6')}</p>
                                <p className="roboto mt-[20px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[497px]">{t('trading.63')}</p>
                                <p className="roboto mt-[20px] xl:mt-[60px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[497px]">{t('trading.64')}</p>
                            </div>
                            <div className="mt-[40px] xl:mt-0">
                                <p className="mt-[40px] xl:mt-0 manrope text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('trading.65')}</p>
                                <div className="flex gap-[16px] xl:gap-[26px] mt-[20px] xl:mt-[50px]">
                                    <img src={num} className="flex-shrink-0" alt="" />
                                    <div className="mt-[5px] xl:mt-0">
                                        <p className="roboto text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[414px]">{t('trading.66')}</p>
                                        <p className="roboto mt-[46px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[414px]">{t('trading.67')}</p>
                                        <p className="roboto mt-[46px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[414px]">{t('trading.68')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mt-[40px] xl:mt-[100px] flex flex-col md:flex-row gap-[10px] xl:gap-[20px]">
                            <div className="flex flex-col gap-[10px] xl:gap-[20px]">
                                <div className="px-[20px] xl:px-[40px] py-[40px] bg-[#131313] rounded-[20px] md:w-[600px] xl:h-[218px]">
                                    <p className="manrope text-[16px] xl:text-[20px] text-[#FFFFFF]">{t('trading.23')}</p>
                                    <p className="roboto mt-[20px] text-[#FFFFFFB2] text-[12px] xl:text-[14px] font-[300] xl:max-w-[497px]">{t('trading.24')}</p>
                                </div>
                                <div className="px-[20px] xl:px-[40px] py-[40px] bg-[#131313] rounded-[20px] md:w-[600px] xl:h-[218px]">
                                    <p className="manrope text-[16px] xl:text-[20px] text-[#FFFFFF]">{t('trading.25')}</p>
                                    <p className="roboto mt-[20px] text-[#FFFFFFB2] text-[12px] xl:text-[14px] font-[300] xl:max-w-[497px]">{t('trading.26')}</p>
                                </div>
                            </div>
                            <div className="relative overflow-hidden">
                                <img src={f4} className="h-full w-full object-cover" alt="" />
                                <p className="roboto italic bottom-[20px] xl:bottom-[50px] left-[20px] right-[20px] xl:left-[50px] text-[#FFFFFFB2] text-[12px] xl:text-[14px] xl:max-w-[497px] absolute">{t('trading.27')}</p>
                            </div>
                        </div>
                        <div className="mt-[60px] xl:mt-[100px] flex flex-col items-center  ">
                            <p className="text-center manrope text-[16px] xl:text-[20px] leading-[1.2] font-[500]">{t('trading.28')}</p>
                            <div className="xl:w-[807px] mt-[20px] xl:mt-[40px] flex flex-col gap-[12px]">
                                {faq3.map((item, index) => {
                                    const isOpen = openIndex === index;
                                    return (
                                        <div
                                            key={index}
                                            className="border-[2px] rounded-[40px] border-[#0000001A] py-[15px] cursor-pointer select-none"
                                            onClick={() => setOpenIndex(isOpen ? null : index)}
                                        >
                                            <div className="flex justify-between items-center">
                                                <p className="roboto text-[14px] xl:text-[16px] text-[#000000B2] px-[20px] xl:px-[40px]">
                                                    {item.question}
                                                </p>
                                                <motion.div
                                                    animate={{ rotate: isOpen ? 45 : 0 }}
                                                    transition={{ duration: 0.3 }}
                                                    className="flex-shrink-0"
                                                >
                                                    <div className="w-[30px] mx-[15px] h-[30px] flex items-center justify-center flex-shrink-0 bg-[#131313] rounded-full"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"> <path d="M12.8577 8.38494H8.66511V12.8104C8.66511 13.0452 8.57676 13.2703 8.41951 13.4363C8.26226 13.6023 8.04898 13.6955 7.8266 13.6955C7.60421 13.6955 7.39093 13.6023 7.23368 13.4363C7.07643 13.2703 6.98809 13.0452 6.98809 12.8104V8.38494H2.79554C2.57315 8.38494 2.35988 8.29169 2.20263 8.12571C2.04537 7.95972 1.95703 7.73459 1.95703 7.49985C1.95703 7.26511 2.04537 7.03998 2.20263 6.874C2.35988 6.70801 2.57315 6.61476 2.79554 6.61476H6.98809V2.18929C6.98809 1.95455 7.07643 1.72942 7.23368 1.56344C7.39093 1.39745 7.60421 1.3042 7.8266 1.3042C8.04898 1.3042 8.26226 1.39745 8.41951 1.56344C8.57676 1.72942 8.66511 1.95455 8.66511 2.18929V6.61476H12.8577C13.08 6.61476 13.2933 6.70801 13.4506 6.874C13.6078 7.03998 13.6962 7.26511 13.6962 7.49985C13.6962 7.73459 13.6078 7.95972 13.4506 8.12571C13.2933 8.29169 13.08 8.38494 12.8577 8.38494Z" fill="white"/> </svg></div>
                                                </motion.div>
                                            </div>

                                            <AnimatePresence>
                                                {isOpen && (
                                                    <motion.div
                                                        initial={{ opacity: 0, height: 0 }}
                                                        animate={{ opacity: 1, height: "auto" }}
                                                        exit={{ opacity: 0, height: 0 }}
                                                        transition={{ duration: 0.4, ease: "easeInOut" }}
                                                        className="overflow-hidden"
                                                    >
                                                        <p className="roboto mx-[20px] xl:mx-[40px] mt-[15px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[807px]">
                                                            {item.answer}
                                                        </p>
                                                    </motion.div>
                                                )}
                                            </AnimatePresence>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                )}
                {active === 4 && (
                    <div className="mt-[50px]">
                        <div className="flex flex-col xl:flex-row justify-between">
                            <div>
                                <p className="manrope xl:text-[48px] text-[24px] leading-[1.2] font-[500]">{t('trading.7')}</p>
                                <p className="roboto mt-[20px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[497px]">{t('trading.79')}</p>
                                <p className="manrope text-[16px] xl:text-[20px] font-[500] leading-[1.2] xl:mt-[40px] mt-[20px]">{t('trading.80')}</p>
                                <p className="roboto mt-[20px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[497px]">{t('trading.81')}</p>
                            </div>
                            <div className="mt-[40px] xl:mt-0">
                                <p className="mt-[40px] xl:mt-0 manrope text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('trading.82')}</p>
                                <div className="flex gap-[16px] xl:gap-[26px] mt-[20px] xl:mt-[50px]">
                                    <img src={num} className="flex-shrink-0" alt="" />
                                    <div className="mt-[5px] xl:mt-0">
                                        <p className="roboto text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[414px]">{t('trading.83')}</p>
                                        <p className="roboto mt-[46px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[414px]">{t('trading.84')}</p>
                                        <p className="roboto mt-[46px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[414px]">{t('trading.85')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mt-[40px] xl:mt-[100px] flex flex-col md:flex-row gap-[10px] xl:gap-[20px]">
                            <div className="flex flex-col gap-[10px] xl:gap-[20px]">
                                <div className="px-[20px] xl:px-[40px] py-[40px] bg-[#131313] rounded-[20px] md:w-[600px] xl:h-[218px]">
                                    <p className="manrope text-[16px] xl:text-[20px] text-[#FFFFFF]">{t('trading.23')}</p>
                                    <p className="roboto mt-[20px] text-[#FFFFFFB2] text-[12px] xl:text-[14px] font-[300] xl:max-w-[497px]">{t('trading.24')}</p>
                                </div>
                                <div className="px-[20px] xl:px-[40px] py-[40px] bg-[#131313] rounded-[20px] md:w-[600px] xl:h-[218px]">
                                    <p className="manrope text-[16px] xl:text-[20px] text-[#FFFFFF]">{t('trading.25')}</p>
                                    <p className="roboto mt-[20px] text-[#FFFFFFB2] text-[12px] xl:text-[14px] font-[300] xl:max-w-[497px]">{t('trading.26')}</p>
                                </div>
                            </div>
                            <div className="relative overflow-hidden">
                                <img src={f5} className="h-full w-full object-cover" alt="" />
                                <p className="roboto italic bottom-[20px] xl:bottom-[50px] left-[20px] right-[20px] xl:left-[50px] text-[#FFFFFFB2] text-[12px] xl:text-[14px] xl:max-w-[497px] absolute">{t('trading.27')}</p>
                            </div>
                        </div>
                        <div className="mt-[60px] xl:mt-[100px] flex flex-col items-center  ">
                            <p className="text-center manrope text-[16px] xl:text-[20px] leading-[1.2] font-[500]">{t('trading.28')}</p>
                            <div className="xl:w-[807px] mt-[20px] xl:mt-[40px] flex flex-col gap-[12px]">
                                {faq4.map((item, index) => {
                                    const isOpen = openIndex === index;
                                    return (
                                        <div
                                            key={index}
                                            className="border-[2px] rounded-[40px] border-[#0000001A] py-[15px] cursor-pointer select-none"
                                            onClick={() => setOpenIndex(isOpen ? null : index)}
                                        >
                                            <div className="flex justify-between items-center">
                                                <p className="roboto text-[14px] xl:text-[16px] text-[#000000B2] px-[20px] xl:px-[40px]">
                                                    {item.question}
                                                </p>
                                                <motion.div
                                                    animate={{ rotate: isOpen ? 45 : 0 }}
                                                    transition={{ duration: 0.3 }}
                                                    className="flex-shrink-0"
                                                >
                                                    <div className="w-[30px] mx-[15px] h-[30px] flex items-center justify-center flex-shrink-0 bg-[#131313] rounded-full"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"> <path d="M12.8577 8.38494H8.66511V12.8104C8.66511 13.0452 8.57676 13.2703 8.41951 13.4363C8.26226 13.6023 8.04898 13.6955 7.8266 13.6955C7.60421 13.6955 7.39093 13.6023 7.23368 13.4363C7.07643 13.2703 6.98809 13.0452 6.98809 12.8104V8.38494H2.79554C2.57315 8.38494 2.35988 8.29169 2.20263 8.12571C2.04537 7.95972 1.95703 7.73459 1.95703 7.49985C1.95703 7.26511 2.04537 7.03998 2.20263 6.874C2.35988 6.70801 2.57315 6.61476 2.79554 6.61476H6.98809V2.18929C6.98809 1.95455 7.07643 1.72942 7.23368 1.56344C7.39093 1.39745 7.60421 1.3042 7.8266 1.3042C8.04898 1.3042 8.26226 1.39745 8.41951 1.56344C8.57676 1.72942 8.66511 1.95455 8.66511 2.18929V6.61476H12.8577C13.08 6.61476 13.2933 6.70801 13.4506 6.874C13.6078 7.03998 13.6962 7.26511 13.6962 7.49985C13.6962 7.73459 13.6078 7.95972 13.4506 8.12571C13.2933 8.29169 13.08 8.38494 12.8577 8.38494Z" fill="white"/> </svg></div>
                                                </motion.div>
                                            </div>

                                            <AnimatePresence>
                                                {isOpen && (
                                                    <motion.div
                                                        initial={{ opacity: 0, height: 0 }}
                                                        animate={{ opacity: 1, height: "auto" }}
                                                        exit={{ opacity: 0, height: 0 }}
                                                        transition={{ duration: 0.4, ease: "easeInOut" }}
                                                        className="overflow-hidden"
                                                    >
                                                        <p className="roboto mx-[20px] xl:mx-[40px] mt-[15px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[807px]">
                                                            {item.answer}
                                                        </p>
                                                    </motion.div>
                                                )}
                                            </AnimatePresence>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                )}
                {active === 5 && (
                    <div className="mt-[50px]">
                        <div className="flex flex-col xl:flex-row justify-between">
                            <div>
                                <p className="manrope xl:text-[48px] text-[24px] leading-[1.2] font-[500]">{t('trading.8')}</p>
                                <p className="roboto mt-[20px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[497px]">{t('trading.96')}</p>
                                <p className="manrope text-[16px] xl:text-[20px] font-[500] leading-[1.2] xl:mt-[40px] mt-[20px]">{t('trading.97')}</p>
                                <p className="roboto mt-[20px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[497px]">{t('trading.98')}</p>
                            </div>
                            <div className="mt-[40px] xl:mt-0">
                                <p className="mt-[40px] xl:mt-0 manrope text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('trading.99')}</p>
                                <div className="flex gap-[16px] xl:gap-[26px] mt-[20px] xl:mt-[50px]">
                                    <img src={num} className="flex-shrink-0" alt="" />
                                    <div className="mt-[5px] xl:mt-0">
                                        <p className="roboto text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[414px]">{t('trading.100')}</p>
                                        <p className="roboto mt-[46px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[414px]">{t('trading.101')}</p>
                                        <p className="roboto mt-[46px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[414px]">{t('trading.102')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mt-[40px] xl:mt-[100px] flex flex-col md:flex-row gap-[10px] xl:gap-[20px]">
                            <div className="flex flex-col gap-[10px] xl:gap-[20px]">
                                <div className="px-[20px] xl:px-[40px] py-[40px] bg-[#131313] rounded-[20px] md:w-[600px] xl:h-[218px]">
                                    <p className="manrope text-[16px] xl:text-[20px] text-[#FFFFFF]">{t('trading.23')}</p>
                                    <p className="roboto mt-[20px] text-[#FFFFFFB2] text-[12px] xl:text-[14px] font-[300] xl:max-w-[497px]">{t('trading.24')}</p>
                                </div>
                                <div className="px-[20px] xl:px-[40px] py-[40px] bg-[#131313] rounded-[20px] md:w-[600px] xl:h-[218px]">
                                    <p className="manrope text-[16px] xl:text-[20px] text-[#FFFFFF]">{t('trading.25')}</p>
                                    <p className="roboto mt-[20px] text-[#FFFFFFB2] text-[12px] xl:text-[14px] font-[300] xl:max-w-[497px]">{t('trading.26')}</p>
                                </div>
                            </div>
                            <div className="relative overflow-hidden">
                                <img src={f6} className="h-full w-full object-cover" alt="" />
                                <p className="roboto italic bottom-[20px] xl:bottom-[50px] left-[20px] right-[20px] xl:left-[50px] text-[#FFFFFFB2] text-[12px] xl:text-[14px] xl:max-w-[497px] absolute">{t('trading.27')}</p>
                            </div>
                        </div>
                        <div className="mt-[60px] xl:mt-[100px] flex flex-col items-center  ">
                            <p className="text-center manrope text-[16px] xl:text-[20px] leading-[1.2] font-[500]">{t('trading.28')}</p>
                            <div className="xl:w-[807px] mt-[20px] xl:mt-[40px] flex flex-col gap-[12px]">
                                {faq5.map((item, index) => {
                                    const isOpen = openIndex === index;
                                    return (
                                        <div
                                            key={index}
                                            className="border-[2px] rounded-[40px] border-[#0000001A] py-[15px] cursor-pointer select-none"
                                            onClick={() => setOpenIndex(isOpen ? null : index)}
                                        >
                                            <div className="flex justify-between items-center">
                                                <p className="roboto text-[14px] xl:text-[16px] text-[#000000B2] px-[20px] xl:px-[40px]">
                                                    {item.question}
                                                </p>
                                                <motion.div
                                                    animate={{ rotate: isOpen ? 45 : 0 }}
                                                    transition={{ duration: 0.3 }}
                                                    className="flex-shrink-0"
                                                >
                                                    <div className="w-[30px] mx-[15px] h-[30px] flex items-center justify-center flex-shrink-0 bg-[#131313] rounded-full"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"> <path d="M12.8577 8.38494H8.66511V12.8104C8.66511 13.0452 8.57676 13.2703 8.41951 13.4363C8.26226 13.6023 8.04898 13.6955 7.8266 13.6955C7.60421 13.6955 7.39093 13.6023 7.23368 13.4363C7.07643 13.2703 6.98809 13.0452 6.98809 12.8104V8.38494H2.79554C2.57315 8.38494 2.35988 8.29169 2.20263 8.12571C2.04537 7.95972 1.95703 7.73459 1.95703 7.49985C1.95703 7.26511 2.04537 7.03998 2.20263 6.874C2.35988 6.70801 2.57315 6.61476 2.79554 6.61476H6.98809V2.18929C6.98809 1.95455 7.07643 1.72942 7.23368 1.56344C7.39093 1.39745 7.60421 1.3042 7.8266 1.3042C8.04898 1.3042 8.26226 1.39745 8.41951 1.56344C8.57676 1.72942 8.66511 1.95455 8.66511 2.18929V6.61476H12.8577C13.08 6.61476 13.2933 6.70801 13.4506 6.874C13.6078 7.03998 13.6962 7.26511 13.6962 7.49985C13.6962 7.73459 13.6078 7.95972 13.4506 8.12571C13.2933 8.29169 13.08 8.38494 12.8577 8.38494Z" fill="white"/> </svg></div>
                                                </motion.div>
                                            </div>

                                            <AnimatePresence>
                                                {isOpen && (
                                                    <motion.div
                                                        initial={{ opacity: 0, height: 0 }}
                                                        animate={{ opacity: 1, height: "auto" }}
                                                        exit={{ opacity: 0, height: 0 }}
                                                        transition={{ duration: 0.4, ease: "easeInOut" }}
                                                        className="overflow-hidden"
                                                    >
                                                        <p className="roboto mx-[20px] xl:mx-[40px] mt-[15px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[807px]">
                                                            {item.answer}
                                                        </p>
                                                    </motion.div>
                                                )}
                                            </AnimatePresence>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Switcher;